import useDocumentTitle from "hooks/useDocumentTitle";
import { useForm, FormProvider } from "react-hook-form";
import { useSearchParams } from "react-router-dom";

import { BilateralToggle } from "./components/BilateralToggle";
import { ContractLanguageField } from "./components/ContractLanguageField";
import { CptCodes } from "./components/CptCodes";
import { ExcludedCptCodes } from "./components/ExcludedCptCodes";
import { Header } from "./components/Header";
import { PerDiemToggle } from "./components/PerDiemToggle";
import { ProviderAndPayerSection } from "./components/ProviderAndPayerSection";
import { RuleName } from "./components/RuleName";
import { SubmitCaseRate } from "./components/SubmitCaseRate";

export function CreateCaseRateRulesPage() {
  useDocumentTitle("Create Case Rate Rules");
  const [searchParams] = useSearchParams();
  const asDefault = searchParams.get("asDefault") === "true";

  const methods = useForm({
    defaultValues: {
      provider: [],
      payerName: "",
      groupName: "",
      cptCodes: [],
      excludedCptCodes: [],
      isPerDiem: false,
      isBilateral: false,
      isDefault: asDefault,
      contractLanguage: "",
    },
  });
  return (
    <FormProvider {...methods}>
      <Header isCaseRate />
      <ProviderAndPayerSection />
      <RuleName />
      <div className="grid">
        <PerDiemToggle />
        <BilateralToggle />
      </div>
      <CptCodes />
      <ExcludedCptCodes />
      <ContractLanguageField ruleType="CASE_RATE" />
      <SubmitCaseRate />
    </FormProvider>
  );
}
